module.exports = __webpack_public_path__ + "static/media/intro1.a7b71586.png";